import { useQuery } from "@tanstack/react-query";
import { roleService } from "@/services/RoleService";

export const roleKeys = {
  all: ['roles'],
  list: (page, searchParams) => [...roleKeys.all, 'list', page, searchParams],
  single: (id) => [...roleKeys.all, id],
};

export const useRoles = (page = 1, searchParams = {}) => {
  return useQuery({
    queryKey: roleKeys.list(page, searchParams),
    queryFn: async () => {
      const response = await roleService.getAllRoles(page, searchParams);
      
      // Return both the roles and pagination data
      return {
        data: response?.data || [],
        pagination: {
          current_page: response?.pagination?.current_page || 1,
          total: response?.pagination?.total || 0,
          per_page: response?.pagination?.per_page || 10,
          last_page: response?.pagination?.last_page || 1
        }
      };
    },
    keepPreviousData: true // Keep displaying previous data while new data is fetched
  });
};

export const useRole = (id, options) => {
  return useQuery({
    queryKey: roleKeys.single(id),
    queryFn: () => roleService.getRole(id),
    enabled: !!id,
    ...options,
  });
}; 